import { sfcApi } from '../../api';
export interface StripeKey {
  id: number;
  publishableKey: string;
}
export interface Intent {
  location_id: number;
  invoice_id: number;
  amount: number;
  access_code?: string;
}

export interface CreatePayment {
  invoice_id: number;
  payment_method: string;
  total: number;
  notes: string;
  transaction_id: string;
  cc_last_4: string;
}
export const stripeApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    createInvoiceIntent: builder.mutation<{ clientSecret: string }, Intent>({
      query: (data) => {
        return {
          url: `stripe/create-invoice-payment-intent`,
          method: 'POST',
          body: data
        };
      },
      invalidatesTags: (result, error, { invoice_id }) => [
        { type: 'Intent', id: result?.clientSecret },
        'Intent'
      ]
    }),
    createPayment: builder.mutation<{ createPayment: CreatePayment }, CreatePayment>({
      query: (data) => {
        return {
          url: `payments/create`,
          method: 'POST',
          body: data
        };
      },
      invalidatesTags: (result, error, { invoice_id }) => [
        { type: 'CreatePayment', id: result?.createPayment?.invoice_id },
        'CreatePayment'
      ]
    }),
    createInvoiceClientPayment: builder.mutation<{ payment: CreatePayment }, CreatePayment & { access_code?: string }>({
      query: (data) => ({
        url: `payments/invoice-client-create`,
        method: 'POST',
        body: data
      }),
    }),
    getPaymentIntent: builder.mutation <
      { payment_intent: { clientSecret: string | null; charge: string | null; last4: string | null } },
      { location_id: number; payment_intent: string }
    >({
        query: (data) => ({
          url: `stripe/get-payment-intent`,
          method: 'POST',
          body: data
        })
    }),
    getStrypeKey: builder.query<{ publishableKey: string }, number>({
  query: (id) => `locations/get-stripe-publishable-key/${id}`,
  providesTags: (result, error, publishableKey) => [{ type: 'StripeKey', publishableKey }]
})
})
});

export const {
  useCreateInvoiceIntentMutation,
  useCreatePaymentMutation,
  useCreateInvoiceClientPaymentMutation,
  useGetPaymentIntentMutation,
  useGetStrypeKeyQuery
} = stripeApi;

// Preferred export name. The legacy `useGetStrypeKeyQuery` (typo) is still
// exported above for backwards compatibility; new code should use this one.
export const useGetStripeKeyQuery = useGetStrypeKeyQuery;